export function removeBeforeFirstDash(str: string) {
  const firstDashIndex = str.indexOf('-');
  if (firstDashIndex === -1) return str; // No dash found
  if (firstDashIndex === str.length - 1) return str; // Dash at the end
  return str.slice(firstDashIndex + 1);
}
